import { render, staticRenderFns } from "./Continue.vue?vue&type=template&id=677b5ce8&scoped=true&"
import script from "./Continue.vue?vue&type=script&lang=js&"
export * from "./Continue.vue?vue&type=script&lang=js&"
import style0 from "./Continue.vue?vue&type=style&index=0&id=677b5ce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677b5ce8",
  null
  
)

export default component.exports